module.exports = __webpack_public_path__ + "img/13.8c15ac0c.png";